export function diffLines(diff) {
    if (!diff)
        return [];
    let oldLine;
    let newLine;
    let inHunk = false;
    const lines = diff.split(/\r?\n/);
    if (lines.at(-1) === '')
        lines.pop();
    return lines.map(text => {
        const hunk = /^@@ -(\d+)(?:,\d+)? \+(\d+)(?:,\d+)? @@/.exec(text);
        if (hunk) {
            oldLine = Number.isSafeInteger(Number(hunk[1])) ? Number(hunk[1]) : undefined;
            newLine = Number.isSafeInteger(Number(hunk[2])) ? Number(hunk[2]) : undefined;
            inHunk = true;
            return { text, kind: 'hunk' };
        }
        if (text.startsWith('diff --git ') || text.startsWith('@@')) {
            inHunk = false;
            oldLine = undefined;
            newLine = undefined;
            return { text, kind: 'meta' };
        }
        if (!inHunk && (text.startsWith('--- ') || text.startsWith('+++ ')))
            return { text, kind: 'meta' };
        if (text.startsWith('+')) {
            const line = { text, kind: 'added', newLine };
            if (newLine !== undefined)
                newLine += 1;
            return line;
        }
        if (text.startsWith('-')) {
            const line = { text, kind: 'deleted', oldLine };
            if (oldLine !== undefined)
                oldLine += 1;
            return line;
        }
        if (text.startsWith(' ') && inHunk) {
            const line = { text, kind: 'context', oldLine, newLine };
            if (oldLine !== undefined)
                oldLine += 1;
            if (newLine !== undefined)
                newLine += 1;
            return line;
        }
        return { text, kind: 'meta' };
    });
}
//# sourceMappingURL=diff-lines.js.map